import { States } from 'safe'
import {
  SET_WAREHOUSE,
  SET_WAREHOUSES,
  UPDATE_WAREHOUSE,
  DELETE_WAREHOUSE,
  WarehousesTypes,
  UPDATE_WAREHOUSE_EXISTENCE,
} from '../actions/actionTypes'

const initialState: States.Warehouse = {
  warehouses: [],
}

//eslint-disable-next-line
export default (
  state = initialState,
  action: WarehousesTypes
): States.Warehouse => {
  let _warehouses, wIndex
  switch (action.type) {
    case SET_WAREHOUSES:
      return { ...state, warehouses: action.payload }
    case SET_WAREHOUSE:
      return {
        ...state,
        warehouses: [
          ...state.warehouses,
          { ...action.payload },
        ],
      }

    case UPDATE_WAREHOUSE:
      _warehouses = [...state.warehouses]
      wIndex = _warehouses.findIndex((i) => i.id === action.payload.id)
      _warehouses[wIndex] = { ..._warehouses[wIndex], ...action.payload }
      return { ...state, warehouses: _warehouses }

    case DELETE_WAREHOUSE:
      _warehouses = [...state.warehouses]
      wIndex = _warehouses.findIndex((i) => i.id === action.payload.id)
      _warehouses.splice(wIndex, 1)
      return { ...state, warehouses: _warehouses }

    case UPDATE_WAREHOUSE_EXISTENCE:
      _warehouses = [...state.warehouses]
      wIndex = _warehouses.findIndex(
        (warehouse) => warehouse.id === action.payload.idWarehouse
      )
      _warehouses[wIndex].numberOfExistences = action.payload.numberOfExistences
      return { ...state, warehouses: _warehouses }
    default:
      return state
  }
}
